import React from 'react';

import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import { IoDocumentsOutline } from 'react-icons/io5';
import * as RiIcons from 'react-icons/ri';
import * as BsIcons from 'react-icons/bs';
import * as FaIcons from 'react-icons/fa';
import * as CgIcons from 'react-icons/cg';
import * as HiIcons from "react-icons/hi";
import * as ImIcons from 'react-icons/im';

export const SidebarData = [
  {
    title: 'Home',
    path: '/gralta/home',
    icon: <AiIcons.AiFillHome />
  },
  {
    title: 'Catálogos',
    path: '#',
    icon: <BsIcons.BsInboxesFill />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Almacenes',
        path: '/gralta/catalogos/almacenes',
        icon: <FaIcons.FaWarehouse />
      },
      {
        title: 'Categorías',
        path: '/gralta/catalogos/categorias',
        icon: <IoIcons.IoIosListBox />
      },
      {
        title: 'Productos',
        path: '/gralta/catalogos/productos',
        icon: <IoIcons.IoIosList />
      },
      {
        title: 'Paquetes',
        path: '/gralta/catalogos/paquetes',
        icon: <FaIcons.FaBoxOpen />
      }
    ]
  },
  {
    title: 'Movimientos',
    path: '/gralta/movimientos',
    icon: <HiIcons.HiOutlineSwitchHorizontal />
  },
  {
    title: 'Reportes',
    path: '#',
    icon: <CgIcons.CgFileDocument />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

    subNav: [
      {
        title: 'Mov. materiales',
        path: '/gralta/reportes/movimientosMateriales',
        icon: <FaIcons.FaPeopleCarry />
      },
      {
        title: 'Inventario',
        path: '/gralta/reportes/inventario',
        icon: <FaIcons.FaBoxes />
      },
      {
        title: 'Mov. contables',
        path: '/gralta/reportes/movimientosContables',
        icon: <FaIcons.FaMoneyBill />
      },
      {
        title: 'Cuentas',
        path: '/gralta/reportes/cuentas',
        icon: <FaIcons.FaMoneyCheckAlt />
      },
      {
        title: 'Mov. costos',
        path: '/gralta/reportes/movimientosCostos',
        icon: <RiIcons.RiBookMarkFill />
      },
      {
        title: 'Centros de costo',
        path: '/gralta/reportes/centrosCosto',
        icon: <ImIcons.ImBooks/>
      }
    ]
  },
  // {
  //   title: 'Proveedores',
  //   path: '/gralta/proveedores',
  //   icon: <FaIcons.FaUsers />
  // },
  {
    title: 'Plantillas',
    path: '/gralta/plantillas',
    icon: <IoDocumentsOutline />
  },
  {
    title: 'Usuarios',
    path: '/gralta/usuarios',
    icon: <BsIcons.BsFillPeopleFill />
  },
];



// WEBPACK FOOTER //
// ./src/components/SidebarData.js